//
//
//
//
//
//
//

export default {
  name: 'ErrorNotFound',
}
